import {buildUserContextKey} from './build-user-key';
import {readEncryptedValue} from './encrypted-values';
import {loginId, userContextId} from './local-storage-vars';

/**
 * @returns the user context's decrypted localStorage value for the given key, or `undefined` until
 * `loadEncryptedValues` has decrypted it
 */
export function getForUserContextEncrypted(key: string) {
    if (loginId && userContextId) {
        return readEncryptedValue(buildUserContextKey(loginId, userContextId, key)) as any;
    }
    return undefined;
}
